// routes
import { paths } from 'src/routes/paths';

// --------------------------------------------------
// Runtime-first env reader (NO extra file)
// --------------------------------------------------
const env = (key, fallback = '') => {
  // 1) Runtime injected (Docker/Nginx env-config.js)
  if (typeof window !== 'undefined' && window.__ENV__ && window.__ENV__[key] !== undefined) {
    return window.__ENV__[key];
  }

  // 2) CRA build-time fallback (local dev)
  if (typeof process !== 'undefined' && process.env && process.env[key] !== undefined) {
    return process.env[key];
  }

  return fallback;
};

// API
// ----------------------------------------------------------------------
export const HOST_API = env('REACT_APP_API_URL');
export const WEATHER_API_KEY = env('REACT_APP_WEATHER_API_KEY');
export const GOOGLE_API_KEY = env('REACT_APP_GOOGLE_MAPS_API_KEY');
export const WEATHER_API = 'https://api.weatherapi.com/v1';

export const ASSETS_API = env('REACT_APP_ASSETS_API', 'https://api-dev-minimal-v510.vercel.app');

export const FIREBASE_API = {
  // keep commented or convert similarly if you enable later
};

export const AMPLIFY_API = {
  userPoolId: env('REACT_APP_AWS_AMPLIFY_USER_POOL_ID'),
  userPoolWebClientId: env('REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID'),
  region: env('REACT_APP_AWS_AMPLIFY_REGION'),
};

export const AUTH0_API = {
  clientId: env('REACT_APP_AUTH0_CLIENT_ID'),
  domain: env('REACT_APP_AUTH0_DOMAIN'),
  callbackUrl: env('REACT_APP_AUTH0_CALLBACK_URL'),
};

export const MAPBOX_API = env('REACT_APP_MAPBOX_API');

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root;

// MAIN APP URL for authentication redirects
export const MAIN_APP_URL = env('REACT_APP_MAIN_APP_URL');
